// Access gate for the "Open in browser (Microsoft Office)" action on the file
// preview toolbar.
//
// It opens Office/Excel-for-Web via the Microsoft Office Online viewer, which
// needs an anonymously-fetchable URL for the blob — served by the (pending)
// backend endpoint `GET /files/file_web_view_url/{loanId}/{file_storage_name}`
// returning a short-lived Azure SAS URL. Until that endpoint ships the button
// would 404, so it's gated to dev + an allowlist. Visible when EITHER:
//   • the app is running in development (npm start), OR
//   • the signed-in user's email is in the allowlist below.
//
// To change the rollout, edit this file in one place:
//   • Make it generally available → `export const canSeeOfficeWebView = () => true;`
//   • Dev-only                    → drop the allowlist branch.
//   • Different / more people      → edit OFFICE_WEB_VIEW_ALLOWLIST.
export const OFFICE_WEB_VIEW_ALLOWLIST = [
  "dev2@arrowservicing.com",
  "dev1@arrowservicing.com",
];

const ALLOWED = new Set(OFFICE_WEB_VIEW_ALLOWLIST.map((e) => e.toLowerCase()));

const isDev = process.env.NODE_ENV === "development";

// TEMPORARILY DISABLED — the "Open in browser (Microsoft Office viewer)" action
// is turned off while the backend SAS endpoint is pending. To restore, delete
// the early `return false` below.
export const canSeeOfficeWebView = (email) => {
  return false;
  // eslint-disable-next-line no-unreachable
  return isDev || ALLOWED.has((email || "").trim().toLowerCase());
};

export default canSeeOfficeWebView;
